/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Gates the intake sync: only a definition sourced from the IG is submitted back. Only
 * intake-compiled IG definitions exist, so that is the only member.
 */
export type DefinitionSource =
  (typeof DefinitionSource)[keyof typeof DefinitionSource];

export const DefinitionSource = {
  fhir_ig: "fhir_ig",
} as const;
